module.exports = __webpack_public_path__ + "img/知识详情.d1766f19.svg";